import React, { useState, ReactElement, Component, useContext, useEffect, useMemo } from "react";
import { injectIntl } from "react-intl";
import { Row, Col } from "antd";
import { left_menu_item, LeftMenuContext, menu_items} from "../../contexts/left-menu";
import { Link, withRouter } from "react-router-dom";
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";

const UseMenu = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const left_menu_items: left_menu_item[] = useContext(LeftMenuContext)[0],
    [active_key, set_active_key]: [string, React.Dispatch<React.SetStateAction<string>>] = useState(""),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    path = useMemo(() => props.history.location.pathname.substring(1).substring(props.history.location.pathname.substring(1).indexOf("/") + 1), [
      props.history.location.pathname,
    ]),
    { formatMessage } = useMemo(() => props.intl, [props.intl]),
    menu_new: JSX.Element[] = useMemo((): JSX.Element[] => {
      const menu_new_new: JSX.Element[] = [];
      const left_menu_items_new: left_menu_item[] =  (left_menu_items.filter((item:left_menu_item) => item.key !== "kubernetes")).length === 0 && path.includes("workspace-quotas") ? menu_items[3] : left_menu_items;
      for (let i = 0; i < left_menu_items_new.length; i++) {
        const menu_item: any = left_menu_items_new[i].key;
        if (menu_item !== "workspace-quotas" || user_info.role !== "namespaceDeveloper")
          menu_new_new.push(
            <Col sm={24} className="mt-10" key={menu_item}>
              <Link to={`/quotas/${menu_item}`}>
                {/* <Button className={`w-110 ${active_key === menu_item ? 'active' : ''} text-left`} onClick={() => { set_active_key(menu_item) }}>{formatMessage({ id: menu_item })}</Button> */}
                <div
                  className={`left_menu_button w-110 ${active_key === menu_item ? "active" : ""} text-left`}
                  onClick={() => {
                    set_active_key(menu_item);
                  }}
                >
                  {formatMessage({ id: menu_item })}
                </div>
              </Link>
            </Col>
          );
      }
      return menu_new_new;
    }, [left_menu_items, user_info.role, active_key, formatMessage, path]);

  useEffect((): void => {
    set_active_key(path);
  }, [set_active_key, path]);

  return <Row>{menu_new}</Row>;
};

export default injectIntl(withRouter(UseMenu) as any);
